// API/utility functions for InlineApplicationForm.vue

const API_BASE = process.env.VUE_APP_API || process.env.VUE_API || 'https://api.lahtaclinic.ru';
const API_URL = `${API_BASE}/api`;
const ORDER_URL = `${API_BASE}/api/order/sendOrder`;
const ORDER_SEND_SMS_URL = `${API_BASE}/api/order/sendSMS`;
const ORDER_VERIFY_SMS_URL = `${API_BASE}/api/order/verifySMS`;
// const API_URL = 'http://localhost:1337/api';

/**
 * Send order data to backend
 * @param {Object} params - { name, phone, token, sms, comment, time, target, page, title }
 * @returns {Promise<Response>}
 */
export function sendData({ subject, name, phone, token, sms, comment, time, target, page, title, items, total }) {
    const url = ORDER_URL;
    const payload = {
        verifiedToken: token,
        name,
        phone,
        comment,
        time,
        target,
        purpose: "order",
        page,
        title,
        subject,
        sms,
        items,
        total
    };

    return fetch(url, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
    }).then(res => res.json());
}

/**
 * Send SMS for order flow
 * @param {Object} params - { token, phone, purpose, referrer }
 * @returns {Promise<Response>}
 */
export function sendSms({ token, phone, purpose = "order", referrer }) {
    const payload = { token, phone, purpose, referrer };
    return fetch(ORDER_SEND_SMS_URL, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload)
    }).then(res => res.json());
}

/**
 * Verify SMS code for order flow
 * @param {Object} params - { challengeId, sms }
 * @returns {Promise<Response>}
 */
export function verifySms({ challengeId, sms }) {
    const payload = { challengeId, sms };
    return fetch(ORDER_VERIFY_SMS_URL, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload)
    }).then(res => res.json());
}

/**
 * Send stat to Calltouch
 * @param {Object} payload - { fio, phoneNumber, email, target, site, page }
 * @returns {Promise<Response>}
 */
export function sendStatCalltouch({ fio, phoneNumber, email, target, site, page, sessionId = '' }) {
    var ct_site_id = '52925';
    var ct_data = {
        fio,
        phoneNumber,
        email,
        subject: 'Перезвоните мне ' + (target ? target : ''),
        tags: site ? site : '',
        comment: '',
        requestUrl: page,
        sessionId: sessionId || ''
    };
    let _createPropsString = (obj) => {
        let props = Object.assign(obj);
        return Object.keys(props)
            .reduce(function (a, k) {
                a.push(k + "=" + encodeURIComponent(props[k]));
                return a;
            }, [])
            .join("&");
    };
    return fetch('https://api.calltouch.ru/calls-service/RestAPI/requests/' + ct_site_id + '/register/', {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: _createPropsString(ct_data),
    }).then((res) => res.json());
}

export function sendStatYandexMetrika() {
    if (typeof ym === 'function') {
        ym(25121624, 'reachGoal', 'order_success_v2');
    } else {
        console.warn('Yandex.Metrika (ym) is not available');
    }
}